import { selectSiteName } from 'services/site/selectors'
import {
  selectLoggedIn,
  selectGender,
  selectUserId,
  selectTimeZoneOffset,
  selectTimeZone,
  selectDateOfBirth,
  selectDateJoined,
  selectRegion,
  selectCountryCode,
  selectLocality,
  selectAge,
  selectAgeGroup,
  selectHeight,
  selectWeight,
  selectBMITier,
  selectCanShareWithTwitter,
  selectCanShareWithFacebook,
} from 'services/user/selectors'
import {
  selectShouldSeeAds,
  selectIsPremium,
} from 'services/premium/selectors'
import { createSelector } from 'reselect'
import moment from 'moment'

export const selectUserProps = createSelector(
  selectLoggedIn,
  selectUserId,
  selectSiteName,
  selectTimeZone,
  selectTimeZoneOffset,
  selectGender,
  selectDateOfBirth,
  selectDateJoined,
  selectRegion,
  selectCountryCode,
  selectLocality,
  selectAge,
  selectAgeGroup,
  selectHeight,
  selectWeight,
  selectBMITier,
  selectCanShareWithTwitter,
  selectCanShareWithFacebook,
  selectShouldSeeAds,
  selectIsPremium,
  (
    isLoggedIn, userId, siteName, timezone, timezoneOffset, gender, birthdate,
    dateJoined, region, countryCode, locality, age, ageGroup, height, weight,
    bmiGroup, canShareWithTwitter, canShareWithFacebook, shouldSeeAds, isPremium,
  ) => {
    let result = {
      app_name: siteName,
      platform: 'Web',
    }
    if (isLoggedIn) {
      result = { ...result, ...{
        user_id: String(userId),
        timezone_name: timezone,
        timezone_offset: String(timezoneOffset),
        gender: gender ? (gender.toLowerCase() === 'm' ? 'male' : 'female') : null,
        birthdate,
        registration_date: moment(dateJoined).format('YYYY-MM-DD'),
        user_city: locality,
        user_country: countryCode,
        user_region: region,
        age: String(age),
        age_group: ageGroup,
        user_height: String(height),
        user_weight: String(weight),
        user_bmi_group: bmiGroup.code,
        twitter_sharing_permission: String(canShareWithTwitter),
        facebook_sharing_permission: String(canShareWithFacebook),
        ad_free_user_status: String(shouldSeeAds),
        premium_user_status: String(isPremium),
      }}
    }
    return result
  })



// WEBPACK FOOTER //
// ./src/services/events/selectors.js